export default __webpack_public_path__ + "static/media/student2.265ec9ab.gif";